import React from "react";
import PropTypes from "prop-types";
import ClearIcon from "@mui/icons-material/Clear";

function DashboardPanelHeader(props) {
  return (
    <>
      <div>
        {props.panelLocked ||
        props.headerComponent ||
        !props.title ||
        props.panelId == 10 ? null : (
          <ClearIcon
            fontSize="small"
            onClick={props.removePanel}
            id={props.title + "_hiddenclose"}
            sx={{
              backgroundColor: "#154360",
              color: "#154360",
              marginTop: "2px",
              marginRight: "4px",
              borderRadius: "5px",
            }}
          />
        )}
      </div>
      <div style={{ fontFamily: "Cairo" }}>{props.title}</div>
      <div>
        {props.panelLocked ? (
          props.headerComponent
        ) : props.panelId == 10 ? (
          <ClearIcon
            fontSize="small"
            onClick={props.removePanel}
            id={props.title + "_hiddenclose2"}
            sx={{
              backgroundColor: "#154360",
              color: "#154360",
              marginTop: "2px",
              marginRight: "4px",
              borderRadius: "5px",
            }}
          />
        ) : (
          <ClearIcon
            fontSize="small"
            onClick={props.removePanel}
            id={props.panelId}
            sx={{
              backgroundColor: "red",
              marginTop: "0px",
              marginRight: "4px",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          />
        )}
      </div>
    </>
  );
}

export default DashboardPanelHeader;

DashboardPanelHeader.propTypes = {
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
  title: PropTypes.string,
  panelLocked: PropTypes.bool,
  headerComponent: PropTypes.object,
};
